class HeroBanner extends HTMLElement {
  constructor() {
    super();
    this.banner = this.querySelector('.hero-banner');
    this.swiperElement = this.querySelector('swiper-slider');
    
    if (this.swiperElement) {
      this.init();
    }
  }

  init() {
    // Attendre que le swiper soit initialisé
    const checkSwiper = setInterval(() => {
      if (this.swiperElement.swiper) {
        clearInterval(checkSwiper);
        this.swiper = this.swiperElement.swiper;
        this.setupClickable();
        this.setupSlideChange();
        this.setupCustomProgressbar();
      }
    }, 100);
  }

  setupCustomProgressbar() {
    // Fonction pour mettre à jour la progressbar avec une barre fixe de 40px qui glisse
    const updateProgressbar = () => {
      const progressbarFill = this.querySelector('.swiper-pagination-progressbar-fill');
      if (!progressbarFill) return;

      const totalSlides = this.swiper.slides.length;
      const activeIndex = this.swiper.activeIndex;
      
      // La barre totale fait 60px (ou 8rem selon le CSS)
      // La barre de progression fait 40px de large et glisse
      const totalWidth = 80; // 8rem = 80px
      const fillWidth = 53.33; // 2/3 de 80px
      const maxTranslate = totalWidth - fillWidth; // 26.67px de déplacement max
      
      // Calculer la position de translation (de 0 à maxTranslate)
      const translateX = totalSlides > 1 ? (maxTranslate * activeIndex) / (totalSlides - 1) : 0;
      
      progressbarFill.style.transform = `translate3d(${translateX}px, 0px, 0px) scaleX(1) scaleY(1)`;
      progressbarFill.style.width = `${(fillWidth / totalWidth) * 100}%`;
    };

    // Mettre à jour au chargement
    updateProgressbar();

    // Mettre à jour à chaque changement de slide
    this.swiper.on('slideChange', updateProgressbar);
    this.swiper.on('progress', updateProgressbar);
  }

  setupClickable() {
    if (this.banner) {
      this.banner.style.cursor = 'pointer';
      this.banner.addEventListener('click', (e) => {
        // Ne pas déclencher le clic si on clique sur un bouton, lien ou contrôle swiper
        if (
          e.target.closest('.button') ||
          e.target.closest('a') ||
          e.target.closest('.swiper-button-prev') ||
          e.target.closest('.swiper-button-next') ||
          e.target.closest('.swiper-pagination')
        ) {
          return;
        }

        const currentSlide = this.swiper.slides[this.swiper.activeIndex];
        const link = currentSlide?.dataset.slideLink;

        if (link && link !== '') {
          window.location.href = link;
        }
      });
    }
  }

  setupSlideChange() {
    this.swiper.on('slideChange', () => {
      this.updateCursor();
    });
    
    // Mettre à jour le curseur initial
    this.updateCursor();
  }

  updateCursor() {
    const currentSlide = this.swiper.slides[this.swiper.activeIndex];
    const link = currentSlide?.dataset.slideLink;

    if (this.banner) {
      this.banner.style.cursor = link && link !== '' ? 'pointer' : 'default';
    }
  }
}

customElements.define('hero-banner-section', HeroBanner);
